import axios from 'axios';
import _ from 'lodash';

export interface NotificationsApi {
    fetchNotifications(wsId: number, quotaType?: string): Promise<Array<any>>;
    viewNotification(notification: any): Promise<object>;
}

const baseUrl = '/api/osint';

export class NotificationsAPI implements NotificationsApi {
    async fetchNotifications(wsId: number, userId: string) {
        const { data } = await axios.get<any>(`${baseUrl}/notifications`, {
            params: {
                type: 'Export',
                workspace: wsId,
            },
        });

        return data?.map((notification) => {
            const result = notification;
            if (result.metaData) {
                _.forOwn(result.metaData, (value, key) => {
                    result[key] = value;
                });
            }
            delete result.metaData;
            return result;
        });
    }

    async viewNotification(notification: any): Promise<object> {
        return await axios.put<any>(`${baseUrl}/notifications/${notification.notificationId}/viewed`);
    }
}
